import { LocationMap } from "./components/location-map/LocationMap.tsx";

const Map = () => {
    return <LocationMap />;
};

export default Map;
